// extracted by mini-css-extract-plugin
module.exports = {"feed":"Feed_feed__1ZLaV"};